import moment from 'moment';

import { Base } from './_base.model';

export class SpeakerValidation extends Base {
  id: number;
  type_id: string;
  status_id: string;
  validated_at: Date;
  user_id: string;
  user: any;
  editing: boolean;
  files: any[];
  file: any;
  deserialize(obj: any) {
    Object.assign(this, obj);
    [
      'validated_at',
    ].forEach(field => {
      if (this[field]) {
        this[field] = moment(this[field]).toDate();
      }
    });
    return this;
  }
}
